import * as arabic from '../languageFiles/AR.module.json'
import * as english from '../languageFiles/EN.module.json'
import LocalizedStrings from 'react-localization';

export default new LocalizedStrings({ ar: arabic.ar, en: english.en });
